export default __webpack_public_path__ + "static/typeorm-eb023974e223c9c2ce96af08a053cb01.svg";